<template>
  <div class="mt-component-form">
    <vs-row class="my-4 center-flex" style="justify-content: flex-start;">
      <h5><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint"
          class=""
          color="secondary"
          type="border"
          @click="handleAddRow"
        >{{ $t('항목추가') }}</vs-button>
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          @click="handleRemoveRow"
        >{{ $t('선택삭제') }}</vs-button
        >
      </div>
    </vs-row>

    <!-- 모바일 크기로 볼 때 y 스크롤이 생기는 것을 방지하기 위해 padding 8px을 줌 -->
    <div style="overflow-x: auto; padding-bottom: 8px;">
      <table style="min-width:100%; width: auto;">
        <thead>
        <tr>
          <th v-if="!isPrint" rowspan="2" width="50px">
            <vs-checkbox
              @change="handleCheckAll"
              :value="allChecked"
            ></vs-checkbox>
          </th>
          <th rowspan="2" style="min-width: 200px;">{{ $t('유해/위험요인 발생 공정') }}<br/>(어떤 공정/행동 중이였는가?)</th>
          <th rowspan="2" style="min-width: 300px;">{{ $t('유해·위험요인 파악') }}<br/>(위험한 상황을 발생시킨 주 원인)</th>
          <th rowspan="2" style="min-width: 300px;">{{ $t('현재 적용되어 시행중인 대책') }}<br/>(현재 시행중인 조치는 무엇인가?)</th>
          <th rowspan="2" style="min-width: 300px;">{{ $t('개선대책') }}<br/>(추가적으로 필요한 조치는 무엇인가?)</th>
          <th colspan="3" width="384px" style="min-width: 384px;">{{ $t('조치계획') }}</th>
        </tr>
        <tr>
          <th>{{ $t('담당자') }}</th>
          <th>{{ $t('개선기간') }}</th>
          <th>{{ $t('완료일자') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(row, rowIndex) in list" :key="`${rowIndex}-${row.id}`">
          <td v-if="!isPrint">
            <vs-checkbox
              v-model="row.input_check"
              :readonly="readonly"
            ></vs-checkbox>
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_1 }}</p>
            <ml-input v-else :readonly="readonly" v-model="row.input_1" class="w-full"/>
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_2 }} </p>
            <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_2" />
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_3 }} </p>
            <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_3" />
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_4 }} </p>
            <ml-textarea v-else :readonly="readonly" rows="3" v-model="row.input_4" />
          </td>

          <td>
            <p v-if="isPrint"> {{ row.input_5 }}</p>
            <ml-input v-else :readonly="readonly" v-model="row.input_5" class="w-full"/>
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_5 }} ~ {{ row.input_6 }}</p>
            <div v-else class="">
              <date-selector v-model="row.input_5" class="py-1"/>
              <date-selector v-model="row.input_6" class="py-1"/>
            </div>
          </td>
          <td>
            <p v-if="isPrint"> {{ row.input_7 }}</p>
            <ml-input v-else :readonly="readonly" v-model="row.input_7" class="w-full"/>
          </td>

        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import CheckTypeASelector from '@/components/selector/CheckTypeASelector'
import DateSelector from "@/components/selector/DateSelector.vue";
export default {
  name: 'TableRiskAppraisal589',
  components: {
    DateSelector,
    CheckTypeASelector,
    DisasterClassSelector,

  },
  props: {
    title: {
      type: String,
      default: () => '4M 위험성 평가표'
    },
    isPrint: Boolean,
    readonly: Boolean,
    hideCodeNumber: Boolean,
    value: Array,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.list = value
      }
    },
    list: {
      immediate: false,
      deep: true,
      handler(value) {
        this.$emit("input", value)
      }
    }
  },
  computed: {
    allChecked () {
      let allCheck = true;
      for (const item of this.list) {
        if (!item.input_check) {
          allCheck = false
          break;
        }
      }
      return allCheck;
    },

  },
  data () {
    return {
      list: []
    }
  },
  methods: {

    handleCheckAll (e) {
      const checked = e.target.checked
      this.list.forEach(e => {
        e.input_check = checked
      })
    },

    handleAddRow () {
      this.list.push({
        id: this.list.length,
        input_check: false,
        input_1: '',
        input_2: '',
        input_3: '',
        input_4: '',
        input_5: '',
        input_6: '',
        input_7: '',
      })
    },
    handleRemoveRow () {
      this.list = this.list.filter(x => x.input_check === false)
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bl {
  border-left: $border;
}

.bb {
  border-bottom: $border;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #000;
    padding: 15px 8px;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;

    &.link {
      color: #0085ff;
    }

    div {
      min-height: 18px;
    }
  }
}
</style>

